/**
 * Created by user on 2020/6/5.
 */

import { findModulesPackagePaths } from './lib/find-paths';
export { wsFindPackageHasModules } from './lib/ws-find-paths';

export * from './lib/find-paths';

export default findModulesPackagePaths
